// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6753) return "static/chunks/6753.4e99a1888d0beecb.js";
	if (chunkId === 2236) return "static/chunks/2236.51a27dd2636bca7f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1068":"705809cda4f4d326","3718":"055b6917e9357fa1","8300":"4094a469c2324323"}[chunkId] + ".js";
};